<ng-template vdrDialogTitle>{{ title }}</ng-template>

<form>
  <vdr-form-field [label]="'package.applied-for-order' | translate">
    <a class="button-ghost" [routerLink]="['/orders', orderId]">
      <span>{{ orderCode }}</span>
      <clr-icon shape="arrow right"></clr-icon>
    </a>
  </vdr-form-field>

  <vdr-form-field
    [label]="'common.current-sku' | translate"
    for="currentSku"
    style="margin-top: 1rem; width: 100%"
    *ngIf="currentVariant"
  >
    <input type="text" readonly [value]="currentName()" />
  </vdr-form-field>

  <vdr-form-field
    [label]="'common.new-sku' | translate"
    for="new-sku"
    style="margin-top: 1rem; width: 100%"
  >
    <div style="width: 100%">
      <product-variant-selector
        (productSelected)="addProductVariant($event)"
      ></product-variant-selector>
    </div>
  </vdr-form-field>

  <vdr-form-field
    [label]="'common.quantity' | translate"
    for="quantity"
    style="margin-top: 1rem; width: 100%"
  >
    <input
      type="number"
      min="1"
      [formControl]="updateForm.get(['currentQuantity'])"
    />
  </vdr-form-field>
</form>

<ng-template vdrDialogButtons>
  <button type="button" class="btn" (click)="cancel()">
    {{ "common.cancel" | translate }}
  </button>

  <button
    type="submit"
    (click)="save()"
    class="btn btn-primary"
    [disabled]="updateForm.pristine || updateForm.invalid"
  >
    {{ "common.save" | translate }}
  </button>
</ng-template>
